// src/components/Modal/PreferenzeCookie.jsx
import React, { useState } from 'react';
import { Modal, Button, Accordion, Form } from 'react-bootstrap';

function PreferenzeCookie({ show, onHide }) {
  // stato interno per il toggle statistici
  const [statisticiEnabled, setStatisticiEnabled] = useState(false);

  const handleSave = () => {
    // qui salvi le preferenze (e.g. invii al back)
    // …
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Preferenze cookie</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Questo sito utilizza i cookie per migliorare la tua esperienza
          durante la navigazione nel sito. Di questi, i cookie classificati
          come <strong>necessari</strong> vengono memorizzati nel browser in
          quanto sono essenziali per le funzionalità di base del sito web.
          Utilizziamo anche cookie di terze parti che ci aiutano ad analizzare
          e capire come utilizzi questo sito web. Questi cookie verranno
          memorizzati nel tuo browser solo con il tuo consenso. Hai anche la
          possibilità di disattivare questi cookie. Tuttavia, la disattivazione
          di alcuni di questi cookie potrebbe influire sulla tua esperienza di
          navigazione.
        </p>

        <Accordion defaultActiveKey="0" flush>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Cookie Tecnici Necessari
            </Accordion.Header>
            <Accordion.Body className="d-flex justify-content-between align-items-center">
              <span>Sempre Attivi</span>
              <Form.Check 
                type="switch" 
                id="switch-necessari"
                label=""
                checked
                disabled
              />
            </Accordion.Body>
          </Accordion.Item>

          {/* Cookie Statistici */}
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Cookie Statistici
            </Accordion.Header>
            <Accordion.Body className="d-flex justify-content-between align-items-center">
              <span>Non Attivi</span>
              <Form.Check 
                type="switch" 
                id="switch-statistici"
                label=""
                checked={statisticiEnabled}
                onChange={e => setStatisticiEnabled(e.target.checked)}
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button className='btn-dark-primary' onClick={handleSave}>
          Salva preferenze
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PreferenzeCookie;
